<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="closeDialog" :size="mobileVersion ? 'fs' : 'sm'" :closable="finished">
    <template slot="header">
        <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
            <div class="flex items-center">
                <h2 class="font-bold ml-2">{{ $t('invoices.dialogs.upload_invoice_progress_header') }}</h2>
            </div>
        </div>
    </template>

    <template slot="main">
      <div class="p-4">
        <ul class="overflow-x-hidden overflow-y-auto file-list">
          <li tabindex="0" class="el-upload-list__item is-ready" v-for="(factura, index) in facturas" :key="factura.uuid" :class="[darkMode ? 'text-white' : 'text-black']">
            <a class="el-upload-list__item-name" style="display: inline;">
              <i class="el-icon-document"></i>
              {{ factura.name }}
            </a>
            <div class="float-right" v-if="progress[index]">
              <span v-if="progress[index].finished" :class="!progress[index].result.success ? 'flex items-center' : ''">
                <base-icon custom="icon" :name="getProgressIcon(index)" size="xs" />
                <base-tooltip-icon v-if="!progress[index].result.success" size="xs" :content="progress[index].result.error" class="ml-2"/>
              </span>
              <i v-else class="icon el-icon-loading" />
            </div>
          </li>
        </ul>
        <el-progress :percentage="percentage" :format="progressFormat"></el-progress>
        <!-- :status="uploadStatus" -->
      </div>
    </template>

    <template slot="footer">
      <div v-if="finished" class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="closeDialog" mode="secondary-phantom-blue"
            :text="$t('app.close')" />
        <base-button class="w-full mx-2" @click="exportResult" mode="secondary-phantom-blue"
            :text="$t('app.export_excel')" />
      </div>
      <div v-else class="flex flex-row w-full justify-between">
        <!-- <base-button v-loading="cancelled" class="w-full mx-2" @click="cancelUpload" mode="secondary-phantom-blue"
            :text="$t('app.cancel')" /> -->
        <base-button :disabled="cancelled" class="w-full mx-2" @click="gotoBackground" mode="secondary-phantom-blue"
            :text="$t('app.sendtobackground')" />
      </div>
    </template>
  </base-dialog-button>
</template>
<script>
import { subirFacturaAPS } from '@/services/invoices/subirFacturaAPS'
import { subirFactura } from '@/services/invoices/subirFactura'
import { exportExcel } from '@/services/excel/exportExcel'
import { bus } from '@/main'
import { i18n } from '@/i18n'
export default {
  name: 'upload-invoice-progress-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => { 
        return {
          idCliente: -1,
          idCIFEmpresa: -1,
          pgeType: null,
          facturas: [],
          autoSend: false,
        }
      }
    },
    recibidas: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      isOpen: this.dialogOpen,
      progress: [],
      cancelled: false,
      idLote: null,
      background: false,
      Progress: class {
        /** @type {String} */ facturaName
        /** @type {Boolean} */ success
        /** @type {String} */ error
        constructor (facturaName = '', success = false, error = null) { this.facturaName = facturaName; this.success = success; this.error = error }
      }
    }
  },
  computed: {
    idCliente: function () {
      return this.params.idCliente
    },
    idCIFEmpresa: function () {
      return this.recibidas ? this.params.idCIFEmpresa : -1
    },
    pgeType: function () {
      return this.recibidas ? null : this.params.pgeType
    },
    facturas: function () {
      return this.params.facturas
    },
    autoSend: function () {
      return this.recibidas ? null : this.params.autoSend
    },
    totalFiles: function () { 
      return this.facturas.length
    },
    progressCount: function () {
      return this.progress.filter(x => x.finished).length
    },
    percentage: function () {
      const res = this.progressCount * 100 / this.totalFiles
      return !isNaN(res) ? res : 0
    },
    finished: function () {
      return this.percentage === 100
    },
    uploadStatus: function () {
      if (!this.percentage === 0) {
        return ''
      }
      const error = this.progress.filter(x => x.finished && !x.result.success).length
      if (error === 0) {
        return 'success'
      }
      if (error === this.progressCount) {
        return 'exception'
      }
      return 'warning'
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
  },
  methods: {
    getProgressIcon: function (index) {
      var iconName = ''
      const data = this.progress[index]
      if (data) {
        if (data.finished) {
          if (data.result.success) {
            iconName = 'check'
          } else {
            iconName = 'cross'
          }
        }
      }
      return iconName
    },
    progressFormat: function (percentage) {
      return `${this.progressCount} de ${this.totalFiles}`
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.resetDialog()
    },
    gotoBackground: function () {
      this.isOpen = !this.isOpen
      this.background = true
      this.$emit('applyDialog', { progress: this.progress, background: true })
      this.$emit('toggleDialog')
      // this.resetDialog()
    },
    applyDialog: function () {
      this.$emit('applyDialog', { progress: this.progress, success: this.progress.filter(x => x.finished && !x.result.success).length })
      if (this.progress.some(x => x.finished && x.result.success)) {
        bus.$emit('changeIt', 'changed menu')
      }
      this.resetDialog()
    },
    closeDialog: function () {
      this.applyDialog()
      this.toggleDialog()
    },
    cancelUpload: function () {
      this.cancelled = true
    },
    resetDialog: function () {
      this.cancelled = false
      this.progress = []
      this.idLote = null
      this.$emit('resetDialog')
    },
    doUploadInvoices: async function () {
      const first = this.facturas[0]
      this.progress.push({ finished: false, result: null })
      this.progress[0].result = await this.uploadInvoice(first)
      this.progress[0].finished = true
      new Promise((resolve, reject) => {
        for (let i = 1; i < this.facturas.length; i++) {
          const factura = this.facturas[i]
          this.progress.push({ finished: false, result: null })
          this.uploadInvoice(factura).then(result => { this.progress[i].result = result })
            .catch(() => { this.progress[i].result = new this.Progress(factura.name, false, i18n.t('feedback.error.internal_error_message')) })
            .finally(() => { this.progress[i].finished = true; if (this.progressCount === this.totalFiles) resolve(this.background) })
        }
      }).then(background => { if (background) this.applyDialog() })
    },
    uploadInvoice: async function (factura) {
      const result = new this.Progress(factura.name)
      if (!this.cancelled) {
        var response = null
        try {
          if (this.recibidas) {
            const params = { idLote: this.idLote, totalLote: this.totalFiles, idCIFEmpresa: this.idCIFEmpresa, idCliente: this.idCliente, }
            response = await subirFacturaAPS([factura], params)
          } else {
            const params = { idLote: this.idLote, totalLote: this.totalFiles, pgeType: this.pgeType, enviarAuto: this.autoSend, multiSend: true, idCliente: this.idCliente }
            response = await subirFactura([factura], params)
          }
          result.success = !response.blnError
          if (response.blnError === true) {
            result.error = i18n.t('feedback.error.formated_api_response_error', response)
          }
          this.idLote = this.idLote || String(Math.floor(Math.random() * 9999) + 1).padStart(4, '0')
        } catch (error) {
          result.success = false
          result.error = i18n.t('feedback.error.internal_error_message')
        }
      } else {
        result.success = false
        result.error = i18n.t('feedback.error.user_canceled_error')
      }
      return result
    },
    exportResult: function () {
      exportExcel({ data: this.progress.map(x => x.result) })
      // exportExcel({ data: this.progress.map(x => x.result), parsers: [{ type: Boolean, callback: value => value ? '✔' : '✖' }] })
    },
  },
  watch: {
    dialogOpen: async function (value, oldValue) {
      if (value && !this.finished) {
        await this.doUploadInvoices()
      }
    }
  }
}
</script>
<style scoped>
.file-list {
    max-height: 130px !important;
}

.file-list .icon {
    opacity: .75;
    color: #606266;
}
</style>
